export default {
  home: {
    rental_pricing: "أسعار الإيجار لهذه الآلة:",
    rentalPriceDesc: "مجاناً لأول {mianfei} دقائق",
    rentalPriceDesc1:
      "{currency}{jifei} لكل {jifeiDanwei} {priceUnitSrting}، الحد الأقصى للشحن هو {currency}{fengeding} خلال 24 ساعة.",
    rentalPriceDesc2:
      "إذا لم يتم إعادة الباور بانك خلال {pOvertimeDay} أيام أو تمت إعادته تالفاً، سيُطبق غرامة بإجمالي {currency}{pOvertimeAmount}(بما في ذلك رسوم الإيجار) مع إشعار مسبق",
    free_period: "فترة مجانية:",
    free_period_desc:
      "لا يوجد رسوم إذا تم إعادة الباور بانك خلال الدقائق {mianfei} الأولى.",
    deposit_desc_1: "هذه المحطة تتطلب وديعة قابلة للاسترداد {currency}{yajin}.",
    deposit_desc_2:
      "إذا كان مطلوبًا دفع وديعة، سيتم استردادها تلقائيًا بمجرد إعادة الباور بانك بحالة جيدة خلال 7 أيام",
    deposit_with_desc_1: "خلال 7 أيام لبطاقات الائتمان",
    deposit_with_desc_2: "خلال 21 يومًا لبطاقات الخصم",
    deposit_desc_vary: "قد تختلف سياسات الوديعة حسب الموقع.",
    return_policy: "سياسة الإرجاع:",
    return_policy_company:
      "يمكن إعادة الباور بانكس في أي محطة تديرها نفس الشركة.",
    return_policy_late:
      "الإرجاع المتأخر (بعد {pOvertimeDay} أيام) أو التلف سينتج عنه تكلفة {currency}{pOvertimeAmount}.",
    minute: "دقيقة",
    price_info:
      "أول {mianfei} دقائق مجانية. الحد الأقصى للتكلفة لمدة 24 ساعة هو {currency}{fengding}. سيتم استرداد وديعتك {currency}{yajin} تلقائيًا بعد إعادتك للباور بانك",
    feature_1: "يشمل جميع أنواع الكابلات: iPhone، Type-C، و Micro-USB",
    feature_2: "يمكن إعادته في أي محطة",
    feature_3: "الشحن اللاسلكي متاح",
    tips_1: "سيتم إعادة وديعتك {currency}{yajin} في نهاية الإيجار",
    tips_2:
      "يمكن استخدام وديعة إعادة الشحن {currency}{yajin} للإيجار، وعند استنفادها يمكن استردادها",
    tips_3:
      "الرصيد الحالي هو {currency}{myyue}، والذي يمكن استخدامه للإيجار مباشرةً",
    submit: "ابدأ الإيجار",
    borrow: "ابدأ الإيجار",
    msg_fail_title: "خطأ",
    msg_fail_content: "فشل الإيجار، يرجى المحاولة مرة أخرى",
    msg_rentcount: "لديك حاليًا {zujieNum} طلبات لم يتم إغلاقها",
    goborrow: "اذهب للشحن!!!",
    nearby: "عرض المحطات القريبة",
    preauth: "التفويض المسبق"
  },
  login: {
    code_title: "التحقق من الرسائل القصيرة",
    phone_number: "رقم الهاتف",
    verification_code: "يرجى إدخال رمز التحقق من الرسائل القصيرة",
    captcha_code: "الرمز",
    send_code: "إرسال الرمز",
    login: "تسجيل الدخول",
    agree: "بالنقر على تسجيل الدخول، فإنك توافق على ",
    readme: "اتفاقية المستخدم",
    msg_fail_login: "فشل تسجيل الدخول",
    msg_success_login: "تم تسجيل الدخول بنجاح",
    msg_fail_user:
      "خطأ في الحصول على معلومات المستخدم. هل تريد المحاولة مرة أخرى؟",
    sign_in_with: "تسجيل الدخول باستخدام",
    no_sms: "لم تتلقى الرسالة النصية",
    retry: "إعادة الإرسال",
    continue_with_whatsapp: "المتابعة فورًا عبر واتساب",
    whatsapp_recommended: "موصى به",
    whatsapp_fastest_easiest: "الأسرع والأسهل",
    whatsapp_no_sms: "لا حاجة لرمز SMS",
    or_use_sms: "أو استخدم الرسائل النصية بدلاً من ذلك",
    scan_qr_whatsapp: "امسح رمز QR بهاتفك وأرسل الرسالة في واتساب لتسجيل الدخول",
    open_in_whatsapp: "افتح واتساب وأرسل الرسالة لتسجيل الدخول",
    waiting_approval: "في انتظار الموافقة...",
    approved_redirecting: "تمت الموافقة! جاري تسجيل الدخول...",
    session_expired: "انتهت صلاحية الجلسة. يرجى المحاولة مرة أخرى"
  },
  confirm: {
    deletecard: "حذف البطاقة",
    addcard: "أدخل تفاصيل البطاقة",
    title: "تأكيد الدفع",
    paynow: "الدفع الفوري",
    SMSConfirm:
      "يرجى الدفع وفقًا للرسالة النصية المستلمة على هاتفك والضغط على زر التأكيد للمتابعة.",
    pay_label: "المبلغ",
    auth_label: "التفويض المسبق",
    price_tips:
      "يمكن سحب رصيدك عند الطلب. قد يستغرق ظهور ذلك في حساب الدفع الخاص بك من 1 إلى 5 أيام عمل.",
    auth_tips:
      "مبلغ التفويض المسبق {0}{1} إلزامي. سيتم خصم مبلغ الإيجار الفعلي عند إرجاع بنك الطاقة.",
    pay_type: "يرجى اختيار طريقة الدفع المفضلة لديك",
    submit: "تأكيد الدفع",
    msg_loading: "تحميل...",
    msg_fail_title: "تحذير",
    msg_fail_payment: "فشل في بدء دفع الوديعة",
    msg_fail_order: "فشل في إنشاء طلب الإيجار",
    msg_fail_support: "النظام غير مدعوم",
    msg_fail_confirm: "تأكيد",
    msg_fail_retry: "إعادة المحاولة",
    msg_fail_cancel: "إلغاء",
    payment_amount: "مبلغ الدفع"
  },
  mine: {
    title: "الملف الشخصي",
    wallet: "محفظتي",
    balance: "رصيدي",
    deposit: "إيداع",
    wallet_in: "شحن",
    wallet_out: "سحب",
    wallet_log: "سجل المحفظة",
    order: "طلب",
    coupon: "قسيمة",
    login_tips: "يرجى تسجيل الدخول",
    msg_fail_title: "خطأ",
    msg_fail_update: "فشل التعديل. يرجى المحاولة مرة أخرى",
    msg_loading: "جار التحميل...",
    msg_fail_user:
      "خطأ في الحصول على معلومات المستخدم. هل ترغب في المحاولة مرة أخرى؟",
    help: "مساعدة",
    setting: "إعدادات",
    logout: "تسجيل الخروج",
    buy: "شراء المعدات"
  },
  msg: {
    appoffline: "التطبيق لم يتم إطلاقه بعد، يرجى الانتظار",
    deletecard: "هل أنت متأكد أنك تريد حذف هذه البطاقة؟",
    no_phone: "رقم الهاتف مطلوب",
    loading: "جار التحميل...",
    title: "تلميح",
    success: "تمت العملية بنجاح",
    error: "خطأ غير معروف. حاول مرة أخرى لاحقًا",
    roleerror: "الأذونات غير كافية. يرجى استشارة المدير.",
    neterror: "فشل الاتصال بالشبكة. حاول مرة أخرى لاحقًا",
    confirm: "تأكيد",
    retry: "إعادة المحاولة",
    cancel: "إلغاء",
    title_fail: "تحذير",
    vieworder: "عرض الطلب",
    success_payment: "اكتمل الدفع",
    success_buy: "اكتمل الشراء",
    fail_payment: "فشل الدفع",
    keyword: "الكلمة المفتاحية",
    ispayorder: "يرجى تأكيد ما إذا كان قد تم الدفع",
    unpay: "غير مدفوع",
    yespay: "مدفوع",
    notopen: "غير مفتوح بعد"
  },
  result: {
    tips: "لعرض الطلبات ومواقع المحطات الأخرى، يرجى تنزيل التطبيق.",
    download: "تحميل",
    title: "تم تأكيد الإيجار",
    gotit: "فهمت",
    price_plan: "معيار الرسوم",
    msg_success: "تم الإيجار بنجاح",
    msg_tips_loading: "يتم إخراج بنك الطاقة، يرجى الانتظار..",
    msg_result_loading: "يتم تأكيد نتيجة الدفع...",
    msg_fail_confirm: "تأكيد",
    btn_usage: "ملاحظة الاستخدام",
    btn_return: "ملاحظة الإرجاع",
    deposit: "الوديعة",
    msg_fail_content: "فشل الطلب. يرجى المحاولة مرة أخرى.",
    price_label: "لكل ساعة",
    price_info:
      "مجانًا لأول {mianfei} دقيقة، الحد الأقصى للرسوم اليومية هو {ccurrency}{fengding}. سيتم خصم الوديعة تلقائيًا عندما يصل الإيجار إلى {ccurrency}{yajin}",
    tips_1: "يرجى جمع بنك الطاقة رقم {number} كما هو موضح في الصورة",
    tips_2:
      "يرجى تنظيم الكابلات وإدخال بنك الطاقة في الفتحة مع الجانب الذي يحتوي على [أسهم لأسفل]",
    msg_note_usage:
      "يحتوي بنك الطاقة على 3 أنواع من الكابلات، يرجى اختيار النوع الذي تحتاجه لجهازك.",
    msg_note_return:
      "يرجى تنظيم الكابلات وإدخال بنك الطاقة في الفتحة مع الجانب الذي يحتوي على [أسهم لأسفل]",
    return_info:
      "عند الإرجاع، تأكد من ترتيب الكابلات بشكل منظم وإدخال الجانب الذي يحتوي على الرقائق المعدنية في مأخذ متاح حتى يصل إلى القاع ويستقر."
  },
  result_msg: {
    loading: "جار التحميل...",
    refresh: "تحديث"
  },
  order: {
    title: "طلب الإيجار",
    in_use: "مستخدم",
    ended: "انتهى",
    msg_error: "فشل الطلب"
  },
  order_item: {
    order_number: "رقم",
    venue_rented: "موقع الاستلام",
    time_rented: "وقت الاستلام",
    venue_returned: "موقع الإرجاع",
    time_returned: "وقت الإرجاع",
    charge_standard: "معيار الرسوم",
    charge_standard_info:
      "{pJifei} {pCurrency} لكل ساعة (الأولى {pMian} دقيقة مجانية)",
    rent_occurred: "تأجير حدث",
    returned: "تم الإرجاع",
    unreturned: "غير مُرجع",
    type_0: "لم يكتمل",
    type_1: "جارٍ الإيجار",
    type_2: "ملغى",
    type_3: "مُرجع",
    type_4: "حدث خطأ",
    type_5: "تجاوز الوقت",
    min: "دقيقة",
    payment: "الدفع"
  },
  setting: {
    title: "الإعدادات",
    lang: "اللغة"
  },
  help: {
    title: "التعليمات"
  },
  wallet_in: {
    title: "شحن الرصيد",
    price_label: "مبلغ الشحن",
    price_placeholder: "يرجى إدخال مبلغ الشحن",
    balance: "الرصيد الحالي",
    price_auto: "اختر مبلغ الدفع",
    price_tips:
      "يمكن سحب رصيدك عند الطلب. قد يستغرق 1-5 أيام عمل للظهور في حساب الدفع الخاص بك.",
    submit: "إرسال",
    loading: "جار التحميل...",
    paying: "جارٍ التحويل إلى صفحة الدفع...",
    msg_title: "نصائح",
    msg_fail_order: "فشل في إنشاء طلب الشحن",
    msg_fail_payment: "فشل في بدء دفع الشحن",
    msg_fail_retry: "أعد المحاولة"
  },
  wallet_out: {
    title: "سحب",
    price_label: "مبلغ السحب",
    price_placeholder: "يرجى إدخال مبلغ السحب",
    balance: "الرصيد الحالي",
    balance_all: "سحب الكل",
    deposit: "الوديعة",
    deposit_tips:
      "هناك طلب إيجار غير مكتمل. الوديعة Ksh{pyajin} غير قابلة للاسترداد",
    submit: "إرسال",
    apply: "تقديم",
    confirm: "تأكيد",
    loading: "جار التحميل...",
    msg_fail_price: "مبلغ السحب غير صحيح",
    msg_fail_balance: "لا يمكن أن يتجاوز مبلغ السحب الرصيد الحالي",
    msg_fail_submit: "يرجى ملء جميع المعلومات المطلوبة",
    msg_title: "خطأ",
    msg_success_content: "تم استرداد المبلغ بنجاح",
    confirmtitle: "نصائح",
    confirmcontent:
      "المحفظة الحالية لا تدعم السحب النقدي. يرجى تسجيل معلومات الاتصال الخاصة بك للمعالجة اليدوية لاسترداد المبلغ",
    payee_name: "اسم المستفيد",
    payee_bankcard: "رقم البطاقة البنكية",
    payee_phone: "الهاتف",
    cancelText: "إلغاء",
    confirmText: "إعادة التطبيق"
  },
  map: {
    在线: "متصل",
    离线: "غير متصل",
    title: "المحطة القريبة",
    result_msg: "لم يتم العثور على محطة قريبة",
    msg_title: "خطأ",
    no_support: "عذرًا! المتصفح الخاص بك لا يدعم خدمات الموقع",
    my_position: "موقعي",
    distance: "المسافة",
    shop_time: "الساعات",
    free: "متاح للتأجير",
    return: "فتحات فارغة متوفرة",
    shop_title: "تفاصيل المكان",
    address: "العنوان",
    go_here: "اذهب إلى هنا"
  },
  time: {
    days: "أيام",
    hours: "ساعات",
    minutes: "دقائق"
  }
};
